<template>
    <div class="main-page">
        <div class="sales-land-page" v-if="salesCard != null">
            <promoLand></promoLand>
            <!-- <CRMflats_filter_top v-if="salesCard.flats_filter_top_init == 'true'" id="land-flats-filter-top"></CRMflats_filter_top> -->
            <mainLand v-if="salesCard.prems_init == 'true'" id="land-prems"></mainLand>
            <neoParkDistrict v-if="projectNameG == 'neopark'"></neoParkDistrict>
            <aboutLand v-if="salesCard.about_init == 'true'" id="land-about"></aboutLand>
            <locationLand v-if="salesCard.location_init == 'true'" id="land-location"></locationLand>
            <aroundLandCards v-if="salesCard.around_cards_init != null && salesCard.around_cards_init == 'true'" id="land-around-cards"></aroundLandCards>
            <aroundLand v-if="salesCard.around_init == 'true'" id="land-around"></aroundLand>
            <disLocationLand v-if="salesCard.district_loc_init == 'true'" id="land-dis-loc"></disLocationLand>
            <moreInfoLandGp v-if="salesCard.gp_more_info_init != null && salesCard.gp_more_info_init == 'true'" id="land-moreinfo-gp"></moreInfoLandGp>
            <moreInfoSecondLandGp v-if="salesCard.gp_more_second_info_init != null && salesCard.gp_more_second_info_init == 'true'" id="land-moreinfo-second-gp"></moreInfoSecondLandGp>
            <!-- Только для Duman -->
            <streetLand v-if="salesCard.street_init == 'true' && projectNameG == 'duman'" id="land-street"></streetLand> 
            <!-- end only for DUMAN -->
            <genplanLand v-if="salesCard.genplan_init == 'true'" :class="{'def-mar' : projectNameG != 'duman' && salesCard.gp_more_info_init != null && salesCard.gp_more_info_init == 'true'}" id="land-genplan"></genplanLand>
            <archLand v-if="salesCard.arch_init == 'true'" id="land-arch"></archLand>
            <moreInfoArch  v-if="salesCard.arch_more_info_init == 'true'" id="land-more-info-arch"></moreInfoArch>
            <commerceLand v-if="salesCard.commerce_init == 'true'" id="land-commerce"></commerceLand>
            <streetLand v-if="salesCard.street_init == 'true' && projectNameG != 'duman'" id="land-street"></streetLand>
            <dvorLand v-if="salesCard.yard_init == 'true'" id="land-yard"></dvorLand>
            <moreInfoLand v-if="salesCard.more_info_init != null && salesCard.more_info_init == 'true'" id="land-moreinfo"></moreInfoLand>
            <lobbiLand v-if="salesCard.lobbi_init == 'true'" id="land-lobbi"></lobbiLand>
            <safeLand v-if="salesCard.safe_init == 'true'" id="land-safe"></safeLand>
            <formLand id="land-form-top"></formLand>
            <flatsLand v-if="salesCard.flats_init == 'true'" id="land-flats"></flatsLand>
            <CRMflats v-if="salesCard.flats_plans_init == 'true'" id="land-plans"></CRMflats>
            <formLand></formLand>
            <galleryLand v-if="salesCard.gallery_init == 'true'" id="land-gallery"></galleryLand>
            <videoLand v-if="salesCard.video_init == 'true'" id="land-video"></videoLand>
            <newsLand v-if="salesCard.news_init == 'true'" id="land-news"></newsLand>
            <contactsLand v-if="salesCard.contacts_init == 'true'" id="land-contacts"></contactsLand>
            <formLand class="over-footer-form"></formLand>
            <infoSectionLand></infoSectionLand>
        </div>
        <div class="global-overlay" :class="{'open' : isOpenSendwich, 'open' : isOpenSendwichMobile}" @click="closeMobileMenu(false)"></div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import promoLand from '@/components/sales-land-partials/land-promo.vue'
    import mainLand from '@/components/sales-land-partials/land-main.vue'
    import aboutLand from '@/components/sales-land-partials/land-about.vue'
    import locationLand from '@/components/sales-land-partials/land-location.vue'
    import disLocationLand from '@/components/sales-land-partials/land-dis-loc.vue'
    import aroundLandCards from '@/components/sales-land-partials/land-around-cards.vue'
    import aroundLand from '@/components/sales-land-partials/land-around.vue'
    import genplanLand from '@/components/sales-land-partials/land-genplan.vue'
    import archLand from '@/components/sales-land-partials/land-arch.vue'
    import streetLand from '@/components/sales-land-partials/land-street.vue'
    import commerceLand from '@/components/sales-land-partials/land-commerce.vue'
    import dvorLand from '@/components/sales-land-partials/land-dvor.vue'
    import moreInfoLandGp from '@/components/sales-land-partials/land-more-info-gp.vue'
    import moreInfoSecondLandGp from '@/components/sales-land-partials/land-more-second-info-gp.vue'
    import moreInfoLand from '@/components/sales-land-partials/land-more-info.vue'
    import moreInfoArch from '@/components/sales-land-partials/land-arch-more-info.vue'
    import lobbiLand from '@/components/sales-land-partials/land-lobbi.vue'
    import safeLand from '@/components/sales-land-partials/land-safe.vue'
    import flatsLand from '@/components/sales-land-partials/land-flats.vue'
    import galleryLand from '@/components/sales-land-partials/land-gallery.vue'
    import videoLand from '@/components/sales-land-partials/land-video.vue'
    import newsLand from '@/components/sales-land-partials/land-news.vue'
    import contactsLand from '@/components/sales-land-partials/land-contacts.vue'
    import infoSectionLand from '@/components/sales-land-partials/land-info.vue'
    
    import formLand from '@/components/forms/form-sales-land.vue'
    import CRMflats from '@/components/flats-crm/flats-crm-section.vue'
    // import CRMflats_filter_top from '@/components/flats-crm/flats-crm-filter-top.vue'
    import neoParkDistrict from '@/components/sales-land-partials/neopark/neopark-district.vue';

    
    export default {
        name: 'main--page',
        components: {
            promoLand,
            mainLand,
            aboutLand,
            locationLand,
            disLocationLand,
            aroundLandCards,
            aroundLand,
            genplanLand,
            archLand,
            streetLand,
            commerceLand,
            dvorLand,
            moreInfoLandGp,
            moreInfoSecondLandGp,
            moreInfoLand,
            moreInfoArch,
            lobbiLand,
            safeLand,
            flatsLand,
            galleryLand,
            videoLand,
            newsLand,
            contactsLand,
            infoSectionLand,

            formLand,
            CRMflats,
            // CRMflats_filter_top,
            neoParkDistrict,
        },
        data () {
            return {
                DomLoaded: false,
                iSmobile: false,
                formInit: false,
                projectNameG: window.host,
                lang: window.GlobalLang,
            }
        },
        computed: mapGetters({
            salesCard: 'loadSalesCardContent',
            isOpenFormModal: 'loadisOpenFormModal',
            isOpenSendwich: 'loadIsOpenSendwich',
            isOpenSendwichMobile: 'loadIsOpenSendwichMobile',
        }),
        methods: {
            CapitalizeID(s) {
                if (typeof s !== 'string') return ''
                return s.charAt(0).toUpperCase() + s.slice(1)
            },
            closeMobileMenu(data) {
                this.$store.commit('Open_sendwich_mobile', data);
                document.getElementsByTagName('body')[0].classList.remove('overlay-open');
            },
        },
        created () {
        },
        mounted() {
        }
    }
</script>